import './App.css';
import Weather from "./Weather";

function App() {
  return (
    <div className="container ms-0 p-2">
      <div className="App">
        <Weather />
        <footer>
          <p>This code is coded by <a href="https://github.com/Gayathri2113/project" target="_blank" rel="noreferrer">gayathri</a> and it is hosted on <a href="https://comforting-sunburst-2444bb.netlify.app/" target="_blank" rel="noreferrer">netlify</a></p>
        </footer>
      </div>
    </div >
  );
}

export default App;
